import { connect } from 'react-redux';
import { expandAndFocusCommentPanel } from '../../../DeviationPage/redux/actions';
import { getVisiblePanel } from '../../../DeviationPage/redux/selectors';
var mapStateToProps = function (state, _a) {
    var actionBarType = _a.actionBarType, deviation = _a.deviation;
    return ({
        isCommentPanelOpen: getVisiblePanel(state, actionBarType) === 'comment',
    });
};
var mapDispatchToProps = {
    onToggleCommentPanel: expandAndFocusCommentPanel,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=CommentButton.container.js.map